import { Profile } from "../shared/profile.model";

export class PanelMember {
  id: string;
  discussion: string;
  member: Profile;
  credential: string;
  createdAt: string;
  updatedAt: string;
}
